import { useLang } from '../lib/lang';
import { IMAGES } from '../content/constants';
import { Page, HeroShell, Reveal } from '../components/motion';
import { CTASection, PageSection } from '../components/blocks';

export default function Electrical() {
  const { t } = useLang();
  const c = t.ee;
  return (
    <Page meta={{ ...t.meta.ee, lang: t.lang }}>
      <HeroShell testId="ee-hero" overline={c.hero.overline} lines={c.hero.lines} sub={c.hero.sub} image={IMAGES.substation} />

      <PageSection overline={c.capabilities.overline} testId="ee-capabilities">
        <div className="border-t border-white/10">
          {c.capabilities.items.map((item, i) => (
            <Reveal key={i} delay={i * 0.04}>
              <div data-testid={`ee-capability-${i}`} className="group grid md:grid-cols-12 gap-3 md:gap-6 py-8 md:py-10 border-b border-white/10 items-baseline">
                <span className="md:col-span-1 font-mono text-xs text-volt tracking-[0.2em]">0{i + 1}</span>
                <h3 className="md:col-span-5 font-display text-xl md:text-3xl font-bold tracking-tight text-white group-hover:text-volt transition-colors duration-500">
                  {item.t}
                </h3>
                <p className="md:col-span-6 text-sm text-zinc-400 leading-relaxed">{item.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </PageSection>

      <section data-testid="ee-solar-strip" className="border-t border-white/10 relative overflow-hidden group">
        <img src={IMAGES.solar} alt="Solar PV installation" className="img-treated w-full aspect-[21/8] object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-transparent to-obsidian/40" />
      </section>

      <CTASection title={c.cta} btn={c.cta} />
    </Page>
  );
}
